import { render, staticRenderFns } from "./SchemaForm.vue?vue&type=template&id=aba46968"
import script from "./SchemaForm.vue?vue&type=script&lang=js"
export * from "./SchemaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports